
const digest = '847b2c4c3a7b0fddf4925a7110e34b0faa19c11c80ee01278cb86ed8d81e405c';
const classes = {"item":"_item_1y3kg_1","head":"_head_1y3kg_10","title":"_title_1y3kg_15"};
const css = `._item_1y3kg_1 {
  display: flex;
  flex-direction: column;
  gap: 15px;
  font-family: Rubik, "sans-serif";
  font-size: 14px;
  border-bottom: 1px solid #ecedf3;
  padding: 0 24px 24px 24px;
}
._item_1y3kg_1 ._head_1y3kg_10 {
  display: flex;
  flex-direction: row;
  align-items: center;
}
._item_1y3kg_1 ._head_1y3kg_10 ._title_1y3kg_15 {
  flex: 1;
  font-weight: 500;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  